import { routesNames } from '@/core/constants'
import TermoDesentranhamentoRedigir from '@/views/pages/ata/acessar/gestao-da-ata/documentos/desentranhamento/redigir/TermoDesentranhamentoRedigir.vue'
import TermoDesentranhamentoAssinar from '@/views/pages/ata/acessar/gestao-da-ata/documentos/desentranhamento/assinar/TermoDesentranhamentoAssinar.vue'
import TermoDesentranhamentoJuntar from '@/views/pages/ata/acessar/gestao-da-ata/documentos/desentranhamento/juntar/TermoDesentranhamentoJuntar.vue'

export default [
	{
		name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
		path: 'redigir',
		component: TermoDesentranhamentoRedigir,
	},
	{
		name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO,
		path: 'assinar',
		component: TermoDesentranhamentoAssinar,
	},
	{
		name: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO,
		path: 'juntar',
		component: TermoDesentranhamentoJuntar,
	},
]
